import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { View } from "./View";

export interface IOnboardingStepProps {
  isActive: boolean;
  handleNext: () => void;
  
}

export interface IOnboardingStepViewProps {
  onSubmit: () => void;
}

export interface IOnboardingViewProps {
  step: number;
  stepsPerPage: number;
  totalSteps: number;
  handleNext: () => void;
  handlePrevious: () => void;
  handleComplete: () => void;
  handleCancel: () => void;
}

export const Onboarding = () => {
  const [step, setStep] = useState(1);

  const navigate = useNavigate();

  const stepsPerPage = 3;
  const totalSteps = 6;

  const handleNext = () => {
    step < totalSteps && setStep(step + 1);
  };
  const handlePrevious = () => {
    step > 1 && setStep(step - 1);
  };
  const handleComplete = () => {
    // setStep(3);
    navigate("/");
  };
  const handleCancel = () => {
    // setStep(1);
    navigate("/");
  };

  return (
    <View
      step={step}
      stepsPerPage={stepsPerPage}
      totalSteps={totalSteps}
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      handleComplete={handleComplete}
      handleCancel={handleCancel}
    />
  );
};
